import { render, staticRenderFns } from "./CommonInfoWrapper.vue?vue&type=template&id=5e06d033&scoped=true&"
import script from "./CommonInfoWrapper.vue?vue&type=script&lang=js&"
export * from "./CommonInfoWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CommonInfoWrapper.vue?vue&type=style&index=0&id=5e06d033&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e06d033",
  null
  
)

export default component.exports